import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { OverrideToggle, TenantOverride } from './tenant-override.models';
import { appConfig, clientConfig } from '../../constant/app.constant';

@Injectable({
  providedIn: 'root'
})
export class TenantOverrideService {
  private readonly pTenantOverrideToggles$ = new BehaviorSubject<OverrideToggle[]>([]);
  private readonly pTenantOverride$ = new BehaviorSubject<TenantOverride | null>(null);
  private readonly _url = `${appConfig.BASE_URL}api/tenant`;

  constructor(httpClient: HttpClient) {
      const tenantName = clientConfig.TENANTNAME;
      httpClient
      .get<TenantOverride>(`${this._url}?tenantName=${encodeURIComponent(tenantName)}`)
      .pipe(catchError(() => of(new TenantOverride())))
      .subscribe((tenantOverride: TenantOverride) => {
        if (tenantOverride) {
          this.pTenantOverride$.next(tenantOverride);
          this.pTenantOverrideToggles$.next(tenantOverride.overrideToggles);
        }
      });
  }

  /**
   * Subscribe to get a list of the tenant's override toggles
   * @returns An observable with a list of OverrideToggles
   */
  get overrideToggles(): Observable<OverrideToggle[]> {
    return this.pTenantOverrideToggles$.asObservable();
  }

  /**
   * Check if a specific toggle is enabled for the tenant
   * @param toggle The toggle to check
   * @returns True if the toggle is enabled
   */
  isToggleEnabled(toggle: OverrideToggle): boolean {
    return this.pTenantOverrideToggles$.value.includes(toggle);
  }

  /**
   * Get the return charge warning text configured for the tenant
   * @returns The warning text or null if not configured
   */
  getReturnChargeWarningText(): string | null {
    return this.pTenantOverride$.value?.returnChargeWarningText || null;
  }

    /**
   * Get the information checkbox text configured for the tenant
   * @returns The text or null if not configured
   */
  getInformationCheckBoxText(): string | null {
    return this.pTenantOverride$.value?.informationCheckBoxText || null;
  }
}
